<template>
  <div class="template-container">
    <div class="culture-container" v-if="dropdownData.length > 1">
      <div class="top-form f-clear">
        <div class="dropdown-container f-right">
          <cert-dropdown
            :id="'culture-dropdown'"
            :dropdown-values="dropdownData"
            :dropdown-default-text="currentCulture.name"
            @change="changeCulture"
          />
        </div>
        <div class="input-name f-right">{{ $t('template_viewer_lang_dropdown') }}</div>
      </div>
    </div>
    <component
      :is="template"
      :template-options="previewOptions"
      :series-data="seriesData"
      :current-culture="currentCulture"
    />
  </div>
</template>

<script>
import Template1 from '@/components/templates/Template1'
import CertDropdown from './form/CertDropdown'
export default {
  name: 'CertTemplateViewer',
  props: {
    previewOptions: Object,
    seriesData: Object,
    currentCulture: Object,
    availableCultures: Array,
  },
  data () {
    return {
      template: 'Template1',
    }
  },
  components: {
    Template1,
    CertDropdown,
  },
  methods: {
    changeCulture (value) {
      this.currentCulture.name = value.text
      this.currentCulture.culture = value.value
    },
  },
  computed: {
    dropdownData () {
      let arr = []
      this.availableCultures.forEach((x) => arr.push({ value: x.culture, text: x.name }))
      return arr
    },
  },
}
</script>

<style lang="scss" scoped>
.template-container {
  padding: 48px 0 48px 48px;
  overflow-x: auto;
  white-space: nowrap;
  width: 1048px;
}

.rtl .template-container {
  padding: 48px 48px 48px 0;
}

.top-form {
  padding-bottom: 16px;

  .input-name {
    padding-right: 15px;
    line-height: 35px;
    @include fontSize(14px);
    color: $formDarkBlue;
    font-weight: bold;
  }

  .dropdown-container {
    width: 170px;
  }
}
</style>
